import { render, staticRenderFns } from "./pluginEditor.vue?vue&type=template&id=01c8b93c&scoped=true"
import script from "./pluginEditor.vue?vue&type=script&lang=js"
export * from "./pluginEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c8b93c",
  null
  
)

export default component.exports